import { useSelector } from "react-redux";

export const HistorySelectors = (resource) => {
  const historyList = useSelector(state => state[resource].historyList);
  const loading = useSelector(state => state[resource].historyLoading);

  return { historyList, loading };
};